var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/icon.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-icon";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import "../../db/HTMLBaseIcon.js";
import { ICON_KEY, ICON_SCHEMA } from "../../schema/nodes/icon.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import "../types.js";
import { isNodeSelection } from "../util.js";
var editor = ({ content, contentController, controllerBaseKeyPath, host }) => {
  return html`
    <x-flex space="sm">
      <x-infobox>
        Icons können von der Seite
        <x-link href="https://fonts.google.com/icons" ${css({ textDecoration: "underline" })}>
          https://fonts.google.com/icons
        </x-link>
        genommen werden. Der Name der Icons kann einfach als Text eingefügt werden. Dabei müssen alle Buchstaben klein
        geschrieben werden und Leerzeichen durch Unterstriche ersetzt werden. <br />
        Zum Beispiel: Check Circle -> check_circle
      </x-infobox>
      <x-input placeholder="Icon" ${contentController.field(...controllerBaseKeyPath, "icon")}></x-input>
      <x-buildify-color-picker
        placeholder="Farbe"
        ${contentController.field(...controllerBaseKeyPath, "color")}
      ></x-buildify-color-picker>
      <x-buildify-spacing-picker
        placeholder="Größe"
        ${contentController.field(...controllerBaseKeyPath, "size")}
      ></x-buildify-spacing-picker>
    </x-flex>
  `;
};
var icon = () => ({
  node: {
    name: ICON_KEY,
    schema: ICON_SCHEMA()
  },
  menuItems: [
    {
      label: "Icon",
      icon: "emoticon",
      run: (view) => runInsertNode(ICON_KEY)(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor
});
var NodeIcon = class extends BuildifyLitElement {
  content({ content, mode }) {
    return html`
      <x-icon ${css({ color: content?.color ?? "#000", fontSize: content?.size ?? "24px" })}>
        ${content?.icon ? content.icon : "question_mark"}
      </x-icon>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          fontSize: "20px",
          whiteSpace: "normal",
          display: "inline-block",
          verticalAlign: "middle"
        }
      }
    ];
  }
};
NodeIcon = __decorateClass([
  customElement("node-icon")
], NodeIcon);
export {
  NodeIcon,
  icon
};
